import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, notification } from 'antd';
import { compose } from 'redux';
import get from 'lodash/get';
import { pending } from 'redux-saga-thunk';
import { fromEntities, fromResource } from '../store/selectors';
import { modalHide, modalShow } from '../store/modal/actions';
import { isOpen } from '../store/modal/selectors';
import CreativeTab from '../components/organisms/CreativeTab';
import { resourceDeleteRequest, resourceListReadRequest } from '../store/resource/actions';
import { emptyEditRecord, setEditRecord } from '../store/updateCreative/actions';

class CreativeTabContainer extends Component {
  state = {
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        render: (text, record) => (
          <Button type="link" onClick={() => this.props.showCreativeModal(record)}>
            {text || record.creative_service_id}
          </Button>
        ),
      },
      {
        title: 'Type',
        dataIndex: 'type',
        render: (text, record) => (
          <span>
            ({record.width}x{record.height}) {record.creative_type}
          </span>
        ),
      },
    ],
    archived: false,
    tableState: {
      filteredInfo: { status: ['Unarchived'] },
      page: 0,
      pageSize: 10,
      sortField: null,
      sortOrder: null,
      searchTerm: null,
    },
    selectedRowKeys: [],
  };

  componentDidMount() {
    this.fetchTableData();
  }

  handleArchiveCreative = creative => {
    this.props
      .archiveCreative(creative.creative_service_id)
      .then(() => {
        notification.success({
          message: 'Success',
          description: 'Creative archived.',
          duration: 4,
        });
        this.fetchTableData();
      })
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not archive creative.',
          duration: 0,
        });
      });
  };

  fetchTableData = () => {
    this.props
      .getCreativeList({
        ...this.state.pagination,
        ...this.state.tableState,
        archived: this.state.archived,
      })
      .then(() =>
        this.setState({
          pagination: { ...this.state.pagination, total: this.props.creativeCount },
        })
      )
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not retrieve creative list.',
          duration: 0,
        });
      });
  };

  handleSearchTable(searchTerm) {
    // Clear sorting, pagination and search.
    const { pageSize } = this.state.tableState;
    this.setState(
      {
        tableState: {
          sortField: null,
          sortOrder: null,
          page: 0,
          pageSize,
          searchTerm,
        },
      },
      () => {
        this.fetchTableData();
      }
    );
  }

  toggleArchived = () => this.setState({ archived: !this.state.archived }, this.fetchTableData);

  render() {
    return (
      <CreativeTab
        columns={this.state.columns}
        handleArchiveCreative={this.handleArchiveCreative}
        archived={this.state.archived}
        toggleArchived={this.toggleArchived}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = ({ modal, ...state }) => {
  const creativeList = fromEntities
    .getList(state, 'adminCreative', fromResource.getList(state, 'adminCreative'))
    .map(a => ({ ...a, creative_service_id: parseInt(a.creative_service_id, 10) }));

  return {
    creativeCount: get(state, 'resource.adminCreative.count', 0),
    creativeList,
    loading: pending(state, 'adminCreative'),
    visible: isOpen(modal, 'create-creative'),
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { campaignId },
    },
  }
) => ({
  getCreativeList: ({ searchTerm, current, pageSize, archived }) =>
    dispatch(
      resourceListReadRequest(`${process.env.REACT_APP_INMARKET_CREATIVE_API}/admin/creative`, {
        q: searchTerm,
        campaign_id: parseInt(campaignId, 10),
        page_num: current,
        page_size: pageSize,
        archived: !archived ? undefined : true,
      })
    ),
  showCreativeModal: creative => {
    if (get(creative, 'creative_service_id')) {
      dispatch(setEditRecord(creative));
    }

    dispatch(modalShow('create-creative'));
  },
  onCancel: () => {
    dispatch(modalHide('create-creative'));

    // Timeout because hiding is a slow fade.
    // We don't want to flash the form resetting
    setTimeout(() => dispatch(emptyEditRecord()), 100);
  },
  archiveCreative: id =>
    dispatch(
      resourceDeleteRequest(`${process.env.REACT_APP_INMARKET_CREATIVE_API}/admin/creative/:id`, {
        id,
      })
    ),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CreativeTabContainer);
